import React, { Fragment, useEffect, useState } from "react";
import { Row, Col } from "antd";
import Slider from "react-slick"; // Import Slider
import CardComponent from "@/components/card";
import Container from "@/components/container/Container";
import ButtonComponent from "@/components/button/Button";
import "@/styles/components/inforens.scss";
import { useNavigate } from "react-router-dom";

const Inforens = () => {
  const navigate = useNavigate();
  const data = {
    heading: "Why to choose Inforens?",
    subHeading:
      "Because students loved our guidance, listen to what our guided students have to say about our services.",
    links: [
      "https://www.youtube.com/embed/gBdhAiv0mUM",
      "https://www.youtube.com/embed/7lj--LKLbRM",
      "https://www.youtube.com/embed/0isF6T5Zgvo",
    ],
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768); // Adjust threshold as needed

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Slider settings
  const settings = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <Fragment>
      <div className="inforens-section">
        <Container>
          <div className="heading title-h5-1">{data.heading}</div>
          <Row gutter={[16, 16]}>
            <Col lg={12}>
              <div className="subHeading body-b1-2">{data.subHeading}</div>
            </Col>
          </Row>
          {isMobile ? (
            <div className="video-carousel">
              <Slider {...settings}>
                {data.links.map((link, index) => (
                  <div key={index}>
                    <CardComponent>
                      <div className="video">
                        <iframe
                          width="100%"
                          height="250px"
                          src={link}
                          title={`YouTube video player ${index}`}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        />
                      </div>
                      <div className="know-more">
                        <ButtonComponent
                          label="Know More"
                          onClick={() => navigate("/contact-us")}
                        />
                      </div>
                    </CardComponent>
                  </div>
                ))}
              </Slider>
            </div>
          ) : (
            <Row gutter={[16, 16]} justify="center">
              {data.links.map((link, index) => (
                <Col xs={24} sm={12} md={12} lg={8} key={index}>
                  <CardComponent>
                    <div className="video">
                      <iframe
                        width="100%"
                        height="250px"
                        src={link}
                        title={`YouTube video player ${index}`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      />
                    </div>
                    <div className="know-more">
                      <ButtonComponent label="Know More" onClick={() => navigate("/contact-us")} />
                    </div>
                  </CardComponent>
                </Col>
              ))}
            </Row>
          )}
        </Container>
      </div>
    </Fragment>
  );
};

export default Inforens;
